import React, { useState, useEffect, useRef, createRef } from "react";
import { motion, useViewportScroll, useTransform } from 'framer-motion';

export default function TestimonialSlider(props) {
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const [diff, setDiff] = useState(0);
  const ref = useRef();
  //const testimonialsRef = useRef();
  const testimonialRefs = useRef([]);
  const diffRef = useRef([]);
  const { scrollY } = useViewportScroll();
  const easing = [0.42, 0, 0.58, 1];
  const { title, header, link, items, classes } = props.data;
  useEffect(() => {
    if (!ref.current) return;
    const setValues = () => {
      setElementTop(ref.current.offsetTop);
      setClientHeight(window.innerHeight);
      setDiff(diffRef.current[1].offsetHeight - diffRef.current[0].offsetHeight);
    };
    //console.log('client Height: ', window.innerHeight);
    //console.log('component Height: ', diffRef.current[0].offsetHeight);
    const breakPoints = [];
    breakPoints.push(Math.floor(clientHeight / items.length) - 30);
    breakPoints.push(Math.floor(breakPoints[0] + clientHeight / items.length));
    breakPoints.push(Math.floor(breakPoints[0] + breakPoints[1]));
    //console.log('breakpoint are: ', breakPoints);
    /* const onScroll = () => {
      const scrollTop = diffRef.current[0].getBoundingClientRect().top;
      //scroll range is  clientHeight to 0 for getBoundingClientRect.top
      if (scrollTop < clientHeight && scrollTop > 0) {
        if (scrollTop > breakPoints[2]) {
          console.log('scroll into view first testimonial');
          testimonialRefs.current[0].scrollIntoView({
            block: "nearest",
          });
        }
        if (scrollTop > breakPoints[1] && scrollTop < breakPoints[2]) {
          console.log('scroll into view second testimonial');
          testimonialRefs.current[1].scrollIntoView({
            block: "nearest",
          });
        }
        if (scrollTop > breakPoints[0] && scrollTop < breakPoints[1]) {
          console.log('scroll into view third testimonial');
          testimonialRefs.current[2].scrollIntoView({
            block: "nearest",
          });
        }
      } */
    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);
    //window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
      //window.removeEventListener('scroll', onScroll);
    };
  }, [ref]);
  const transformValue = [elementTop - clientHeight * 0.6, elementTop - 100];
  const y = useTransform(scrollY, transformValue, [0, diff + 50], easing);
  return (
    <div ref={ref} className={`testimonial-slider-section section-gap ${classes}`} id={props.id ? props.id : ''}>
      <div ref={r => diffRef.current[0] = r} className="container">
          <div className="testimonial-content-block text-center section-gap-small">
            <h3 className="secondary-font">{ title }</h3>
          </div>
        <div className="testimonial-slider-block">
          <div ref={r => diffRef.current[1] = r} id="slider-block">
            <motion.ul /* style={{ y }} */ className="row testimonial-slider-list d-flex flex-wrap">
              {items.map((item, index) => {
                return (<li ref={r => testimonialRefs.current[index] = r} key={index} className="col testimonial-slider-item">
                  <div className="item-inner">
                    <div className="testimonial-text">
                      <p>{item.content}</p>
                    </div>
                    <div className="testimonial-bottom-block d-flex flex-wrap align-v-center justify-space">
                      <div className="testimonial-author-block d-flex align-v-center">
                        <div className="author-image">
                          <img src={item.userImage} alt={item.userImageAlt} title={item.userImageTitle} />
                        </div>
                        <div className="author-detail">
                          <p>{item.authorName}</p>
                          <span>{item.authorOccupation}</span>
                        </div>
                      </div>
                      <div className="testimonial-brand-logo">
                        <img src={item.logo} alt={item.logoAlt} width={item.logowidth} title={item.logoTitle} />
                      </div>
                    </div>
                  </div>
                </li>);
              })}
            </motion.ul>
          </div>
        </div>
      </div>
    </div>
  );
}


